module.exports = __webpack_public_path__ + "img/icon-39.5447986d.svg";